<template>
<div class="form-designer-component">
    <div class="mcc-page-header">
        <div class="mu-d-flex mu-flex-column mu-w-100">
            <section class="mu-d-flex">
                <h1 class="mu-mb-00">Form details</h1>
                <details class="mcc-popover mcc-popover--bottom-end">
                    <summary class="mcc-button mcc-button--icon-only ">
                        <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                    </summary>
                    <div class="mcc-popover__content">

                        <p class="mu-mb-00">
                            {{ helpText.title }}
                            <a :href="helpText.url" target="_blank">Read more...</a>
                        </p>
                    </div>
                </details>
            </section>
        </div>
    </div>
    <div class="mcc-container card-padding">
        <nav aria-label="breadcrumb">
            <ol class="mcc-breadcrumb">
                <li>Design</li>
                <li v-if="!showFormBreadCrumb">
                    <a class="table-link" @click="redirectToApplicationList()">Applications</a>
                </li>
                <li v-if="!showFormBreadCrumb">
                    <a class="table-link" href="#" @click.native="redirectToForm()" @click="$router.push(CONTEXT_PATH + '/design/applications/' + formAppplication.id)">{{formAppplication.name}}</a>
                </li>
                <li v-if="showFormBreadCrumb">
                    <a class="table-link" @click="redirectToFormList()">Forms</a>
                </li>
                <li aria-current="page">{{applicationFormNameBreadcrumb}}</li>
            </ol>
        </nav>
        <div class="mcc-row" v-if="!fetchCall">
            <div class="mcc-col colSpinner">
                <div class="spinner-overlay">
                    <div class="spinner-background"></div>
                    <div class="spinner-flex">
                        <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                            <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
        
        
        <div class="mcc-card">
            <div class="mcc-card__body">
                <div class="mcc-row" >
                    <div class="mcc-col">
                        <mcc-alert role="alert" class="mcc-alert mcc-alert--warning mcc-alert--compact" id="disableWarning" v-if="applicationForm.deleted != null" color="warning">
                            <mcc-icon name="error" aria-hidden="true"></mcc-icon>
                            <p>
                                <strong>Warning!</strong>
                                <br />This form has been disabled and cannot be changed.
                                <br />
                                Reason: {{applicationForm.deletedReason}}
                            </p>
                        </mcc-alert>

                        <mcc-alert role="alert" class="mcc-alert mcc-alert--warning mcc-alert--compact" id="disableAppWarning" v-if="formAppplication.deleted != null" color="warning">
                            <mcc-icon name="error" aria-hidden="true"></mcc-icon>
                            <p>
                                <strong>Warning!</strong>
                                <br />This form cannot be changed as application has been disabled.
                                <br />
                                Reason: {{formAppplication.deletedReason}}
                            </p>
                        </mcc-alert>
                        <mcc-alert role="alert" class="mcc-alert mcc-alert--warning mcc-alert--compact" id="adminProtectedWarning" v-if="formAppplication.protected && !isAdmin" color="warning">
                            <mcc-icon name="error" aria-hidden="true"></mcc-icon>
                            <p>
                                <strong>Warning!</strong>
                                <br />This application has been protected by an administrator and cannot be edited.
                            </p>
                        </mcc-alert>

                        <mcc-alert role="alert" class="mcc-alert mcc-alert--warning mcc-alert--compact" id="protectedWarning" v-if="formAppplication.protected && isAdmin" color="warning">
                            <mcc-icon name="error" aria-hidden="true"></mcc-icon>
                            <p>
                                <strong>Warning!</strong>
                                <br />This application has been protected.
                            </p>
                        </mcc-alert>

                    </div>

                </div>
                <div class="mcc-card" v-if="fetchCall">
                    <div class="mcc-card__header">
                        <h2 class="mcc-card__title">Details</h2>
                    </div>
                    <div class="mcc-card__body">
                        <form @submit.prevent="saveUpdatedForm()" id="formId" novalidate>

                            <div style="position:relative">
                                <div v-if="!updateCall" class="spinner-overlay">
                                    <div class="spinner-background"></div>
                                    <div class="spinner-flex">
                                        <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                            <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                            <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                        </svg>
                                    </div>
                                </div>
                                <div class="mt-2" v-if="showFormBreadCrumb" id="applicationId">
                                    <div>
                                        <label class="font-weight-bold mu-mb-05">Application</label>
                                    </div>
                                    <router-link class="name-link" :to="CONTEXT_PATH + '/design/applications/' + formAppplication.id">{{formAppplication.name}}</router-link>
                                </div>
                                <div class="mfc-input-wrapper mu-d-block mfc-form-input-container mu-mb-05 mfc-form-input-wrapper--width">
                                    <label for="form-key">Form key</label>
                                    <input type="text" disabled="" id="form-key" name="form-key" ref="key" maxlength="50" placeholder="Form key" :value="applicationForm.key">
                                </div>
                                <div class="mfc-input-wrapper mu-d-block mfc-form-input-container mu-mb-05 mfc-form-input-wrapper--width">
                                    <label for="name" class="mfc-label--required">Name</label>
                                    <input type="text" id="name" maxlength="50" name="name" required="true" placeholder="Name" :value="applicationForm.name" ref="name" :pattern="nameRegex" @input="updateName($event)" :disabled="applicationForm.deleted != null || formAppplication.deleted != null || (formAppplication.protected && !isAdmin) || !formAppplication.editable">
                                    <div class="mfc-invalid-feedback" v-if="$refs.name && $refs.name.invalidText">{{$refs.name.invalidText}}</div>
                                </div>
                                <div class="mfc-textarea-wrapper mfc-form-input-container mu-mb-05  mfc-form-input-wrapper--width" >
                                    <label for="description" >Description</label>
                                  
                                         <textarea v-if="!formAppplication.editable" id="description" name="description" ref="description" :pattern="descRegex" maxlength="100" :value="applicationForm.description" @input="applicationForm.description = $event.target.value" @change="updateDescription($event)"  :disabled="applicationForm.deleted != null || formAppplication.deleted != null || (formAppplication.protected && !isAdmin) || !formAppplication.editable"></textarea>
                                  
                                         <textarea v-if="formAppplication.editable" id="description" name="description" ref="description" :pattern="descRegex" maxlength="100" :value="applicationForm.description" @input="applicationForm.description = $event.target.value" @change="updateDescription($event)" placeholder="Description" :disabled="applicationForm.deleted != null || formAppplication.deleted != null || (formAppplication.protected && !isAdmin) "></textarea>
                                   
                               
                                    <div class="mfc-invalid-feedback"></div>
                                    <div class="mfc-help-text mu-mt-00">
                                        
                                        <span v-if="applicationForm.description">You have {{100 - applicationForm.description.length}} characters remaining</span>
                                        <span v-else>You have 100 characters remaining</span>
                                    </div>

                                </div>
                                <div class=" mfc-form-input-wrapper--width">
                                    <TagInput :disabled="(formAppplication.protected && !isAdmin) || !formAppplication.editable" :labels="labelsNew" ref="labels" />
                                </div>
                                <div class="mfc-input-wrapper mu-d-block mfc-form-input-container mu-mt-05 mu-mb-05 mfc-form-input-wrapper--width">
                                    <label for="version">Version</label>
                                    <input type="text" id="version" name="version" disabled="" :value="applicationForm.version">

                                </div>
                                <div class="mu-d-flex mu-justify-content-end " v-if="formAppplication.deleted == null && (!formAppplication.protected || isAdmin)" spaced="">
                                    <div role="group" class="mcc-button-group mcc-button-group--spaced">
                                    <button type="button" class="mcc-button mcc-button--soft-warning" v-if="formAppplication.deleted == null && applicationForm.deleted == null" id="disableBtn" @click="disableBtnClick()" title="Disable" :disabled=" !formAppplication.editable" >
                                        <mcc-icon name="unavailable" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Disable</span>
                                    </button>
                                    <button class="mcc-button mcc-button--primary" v-if="formAppplication.deleted == null && applicationForm.deleted != null" id="enableBtn" @click="enableApplicationForm()" title="Enable" type="button" :disabled=" !formAppplication.editable" >
                                        <mcc-icon name="undo" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Enable</span>
                                    </button>
                                    <router-link class="mu-mr-05" v-if="formAppplication.deleted == null && applicationForm.deleted == null" :to="CONTEXT_PATH + '/design/applications/' + applicationId+'/appforms/create?copyFormId='+ applicationForm.id"  >
                                        <button class="mcc-button mcc-button--outline" id="copyBtn" title="Copy" type="button" :disabled=" !formAppplication.editable">
                                            <mcc-icon name="copy" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Copy</span>
                                        </button>
                                    </router-link>
                                    <button class="mcc-button mcc-button--success" title="Save" v-if="formAppplication.deleted == null && applicationForm.deleted == null" id="saveBtn" type="submit" :disabled=" !formAppplication.editable" >
                                        <mcc-icon name="save" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Save</span>
                                    </button>
                                </div>
                            </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="mcc-col mcc-col-md-12 mcc-col-sm-12 mcc-col-xs-12">
                    <div class="mcc-card mt-3">
                        <div class="mcc-card__header mu-d-flex mu-justify-content-between mu-align-items-start mu-flex-wrap">
                            <div>
                                <h2 class="mcc-card__title">Preview</h2>
                            </div>
                            <div class="mu-d-flex">
                                <button class="mcc-button mcc-button--outline" title="Save as template" v-bind:class="{'d-none':!showTemplate}" ref="showTemplate" id="saveAsTemplateBtn" @click="showTemplateDialog">
                                    <mcc-icon name="save" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Save as template</span>
                                </button>
                                <button class="mcc-button mcc-button--primary mu-ml-05" title="Edit" v-bind:class="{'d-none':!(formAppplication.deleted == null && applicationForm.deleted == null && ((!formAppplication.protected || isAdmin)))}" id="editFormDesigner" @click="redirectToFormConfirm()" :disabled=" !formAppplication.editable">
                                    <mcc-icon name="edit" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Edit</span>
                                </button>

                            </div>
                        </div>
                        <div class="mcc-card__body">
                            <div class="form-preview-parent py-2">
                                <fieldset id="fieldSetRenderForm" class="fieldsetContainer" disabled>
                                    <div id="render-canvas"></div>
                                </fieldset>
                                <div class="overlay-div"></div>
                            </div>

                        </div>

                    </div>

                </div>
            </div>
        </div>
    
    </div>
    <div class="mcc-dialog-overlay">
        <dialog class="mcc-dialog mcc-dialog--warning mcc-dialog--xs" ref="disableApplicationFormModal" id="disableApplicationFormModal">
            <form novalidate id="disableForm" @submit.prevent="disableApplicationForm()">
                <section>
                    <div class="mcc-dialog__header">
                        <h2 class="h4 mu-mb-00">Disable</h2>
                        <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="closeDisableDialog()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                    </div>
                    <div class="mcc-dialog__body">
                        <div class="mcc-row">
                            <div class="mcc-col">
                                <div v-if="updateDialog">
                                    <div class="mfc-textarea-wrapper mfc-form-input-container" >
                                        <label for="disableReason" class="mfc-label--required">Disable reason</label>
                                        <textarea id="disableReason" name="disableReason" ref="disableReason" required maxlength="100" rows="6" :pattern="descRegex" @change="updateReason($event)" :value="deletedReason" @input="deletedReason = $event.target.value" character-count=""></textarea>
                                        <div class="mfc-invalid-feedback"></div>
                                        <div class="mfc-help-text mu-mt-00">
                                            <span>You have {{100 - deletedReason.length}} characters remaining</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mcc-dialog__footer">
                        <div class="mcc-button-group mcc-button-group--spaced">
                            <button type="button" class="mcc-button mcc-button--outline" @click="closeDisableDialog()">Close</button>
                            <button type="submit" class="mcc-button mcc-button--warning">Save</button>
                        </div>
                    </div>
                </section>
            </form>
        </dialog>
    </div>
    <div class="mcc-dialog-overlay">
        <dialog class="mcc-dialog mcc-dialog--warning mcc-dialog--xs" ref="editFormConfirmationDialog" id="editFormConfirmationDialog">
            <section>
                <div class="mcc-dialog__header">
                    <h2 class="h4">Edit form</h2>
                    <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="$refs.editFormConfirmationDialog.close()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                </div>
                <div class="mcc-dialog__body">
                    <div class="mcc-row">
                        <div class="mcc-col">This application is protected, do you still want to edit?
                        </div>

                    </div>
                </div>
                <div class="mcc-dialog__footer">

                    <div class="mcc-button-group mcc-button-group--spaced">
                        <button type="button" class="mcc-button mcc-button--outline" @click="$refs.editFormConfirmationDialog.close()">No</button>
                        <button type="submit" class="mcc-button mcc-button--warning" @click="handleEditFormConfirmDialogClose($event)">Yes</button>
                    </div>
                </div>
            </section>
        </dialog>
    </div>
    <div class="mcc-dialog-overlay">
        <dialog class="mcc-dialog mcc-dialog--primary mcc-dialog--xs" color="info" ref="addFormTemplateDialog" id="addFormTemplateDialog">
            <form id="saveTemplateForm" ref="saveFormRef" @submit.prevent="saveTemplate($event)" novalidate  v-if="updateTemplateDialog">
                <section>
                    <div class="mcc-dialog__header">
                        <h2 class="h4">Add form template</h2>
                        <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="closeTemplateDialog()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                    </div>
                    <div class="mcc-dialog__body">
                        <div class="mcc-row">
                            <div class="mcc-col">
                                <div v-if="updateTemplateDialog">
                                    <div class="mfc-input-wrapper mu-d-block mfc-form-input-container">
                                        <label for="formTemplateNameId" class="mfc-label--required">Name</label>
                                        <input type="text" id="formTemplateNameId" name="formTemplateName" ref="formTemplateName" :value="formTemplateData.name" :pattern="nameRegex" @change="updateTemplateName($event)" required="" placeholder="Name" maxlength="50">

                                    </div>
                                    <div class="mfc-textarea-wrapper mfc-form-input-container mu-mt-03">
                                        <label for="formTemplateDescriptionId">Description</label>
                                        <textarea id="formTemplateDescriptionId" name="formTemplateDescription" maxlength="100" ref="formTemplateDescription" placeholder="Description" :value="formTemplateData.description" @input="formTemplateData.description = $event.target.value" :pattern="descRegex" @change="updateTemplateDescription($event)" character-count=""></textarea>
                                        <div class="mfc-invalid-feedback"></div>
                                        <div class="mfc-help-text mu-mt-00">

                                        <span>You have {{100 - formTemplateData.description.length}} characters remaining</span>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                    <div class="mcc-dialog__footer">

                        <div class="mcc-button-group mcc-button-group--spaced">
                            <button type="button" class="mcc-button mcc-button--outline" @click="closeTemplateDialog()">Close</button>
                            <button type="submit" class="mcc-button mcc-button--primary">Save</button>
                        </div>
                    </div>
                </section>
            </form>
        </dialog>
    </div>
</div>
</template>

<script>
import ApplicationFormAPI from "../../../services/ApplicationFormAPI";
import {
    EventBus
} from "../../../services/event-bus";
import constantMessages from "../../../messages";
import TemplateAPI from "../../../services/TemplateAPI";
import Utils from "@/script_utils";
import CONSTANTS from '../constant.js'
import TagInput from "../../common/TagInput.vue";
import {
    handleFormValidation,
    validationMessages,displayErrorMessage, checkFormAndTextareaValidations
} from '../../../formvalid.js';

export default {
    name: "ApplicationFormEdit",
    data() {
        return {
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            nameRegex: constantMessages.PATTERNS["name"],
            descRegex: constantMessages.PATTERNS["description"],
            applicationForm: {
                description: ''
            },
            applicationFormNameBreadcrumb: "",
            showTemplate: false,
            applicationId: this.$route.params.appId,
            formId: this.$route.params.formId,
            labelsNew: [],
            applicationInfo: {},
            updateCall: true,
            formAppplication: {
                id: "",
                name: "",
                protected: false
            },
            isAdmin: false,
            showFormBreadCrumb: false,
            showHelpText: false,
            fetchCall: false,
            helpText: constantMessages.BREADCRUMB_HELP["application.form.edit"],
            deletedReason: "",
            formHtml: "",
            dataLoaded: false,
            updateDialog: false,
            formTemplateData: {
                name: '',
                description: ''
            },
            updateTemplateDialog: false,
            isDescriptionValid: true,
        };
    },
    components: {
        TagInput
    },
    created() {},
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);

        this.showFormBreadCrumb = this.$route.query.hasOwnProperty("path");
        let self = this;

        ApplicationFormAPI.getFormDetails(self.applicationId, self.formId)
            .then(result => {
                if (result == null || result == "") {
                    self.$router.push(
                        self.CONTEXT_PATH + "/design/applications"
                    );
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching application form"
                    });
                    return;
                }
                self.dataLoaded = true;
                self.applicationForm = result.data.applicationForm;
                self.applicationFormNameBreadcrumb = self.applicationForm.name;
                self.formAppplication = result.data.applicationForm.formApplication;
                if (
                    result.data.applicationForm.labels != null &&
                    result.data.applicationForm.labels != ""
                ) {
                    let labelsArray = result.data.applicationForm.labels.split(",");
                    labelsArray.forEach(element => {
                        self.labelsNew.push(element);
                    });
                }
                self.isAdmin = result.data.isAdmin;
                if (
                    self.applicationForm.renderedJson != "" &&
                    self.applicationForm.renderedJson != null
                ) {
                    self.showTemplate = true;
                    window.generatePreview(
                        JSON.parse(self.applicationForm.renderedJson),
                        $("#render-canvas"),
                        0
                    );
                }
                let pageTitle = constantMessages.PAGEHEADER_TITLE["menu.form.details"] + " - " + self.applicationFormNameBreadcrumb;
                EventBus.$emit("update-pageTitle", pageTitle);
            })
            .finally(() => {
                if (self.dataLoaded) {
                    self.fetchCall = true;
                    self.updateTagsDisabledState();
                }
            });
    },
    methods: {
        updateDescription(event) {
            let self = this;
            if (event.target.value.length > 100) {
                displayErrorMessage($(self.$refs.description), constantMessages.MESSAGES["error.description.length"])
                self.$refs.description.classList.add("ms-is-invalid")
                self.isDescriptionValid = false;
            } else if (!event.target.value.match(this.descRegex) && event.target.value != "") {
                displayErrorMessage($(self.$refs.description), constantMessages.MESSAGES["error.description.invalid"])
                self.$refs.description.classList.add("ms-is-invalid")
                self.isDescriptionValid = false;
            } else {
                self.$refs.description.classList.remove("ms-is-invalid")
                self.isDescriptionValid = true;
            }
            self.applicationForm.description = event.target.value;
        },
        updateReason(event) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs.disableReason), "Disable reason is required")
                self.$refs.disableReason.classList.add("ms-is-invalid")
                self.invalidDisableReason = true;
            } else if (!event.target.value.match(this.descRegex)) {
                displayErrorMessage($(self.$refs.disableReason), "Disable reason must be valid")
                self.$refs.disableReason.classList.add("ms-is-invalid")
                self.invalidDisableReason = true;
            } else {
                self.$refs.disableReason.classList.remove("ms-is-invalid")
                self.invalidDisableReason = false;
            }
            self.deletedReason = event.target.value;
        },
        async updateTagsDisabledState() {
            await this.$nextTick()
            if (this.applicationForm.deleted != null || this.formAppplication.deleted != null ||
                (this.formAppplication.protected && !this.isAdmin)) {
                let self = this;
                setTimeout(function () {
                    if ($(self.$refs.labels).length > 0) {
                        $(self.$refs.labels)[0].disabled = true;
                    }
                }, 0)
            }
        },
        saveUpdatedForm() {
            let self = this;
            let form = $('#formId')
            if(!self.isDescriptionValid){
                return;
            }
            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
            }     
            this.applicationForm.labels = this.$refs.labels.value;
            self.updateCall = false;
            ApplicationFormAPI.saveUpdatedForm(
                this.applicationForm,
                this.applicationId,
                this.formId
            ).then(response => {
                self.updateCall = true;
                if (response.error) {
                    for (let k in response.messages) {
                        if (k == "name") {
                            displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES[response.messages[k]])
                            self.$refs.name.classList.add("ms-is-invalid")
                        } else if (k == "labels") {
                            displayErrorMessage($('#tags'), constantMessages.MESSAGES[response.messages[k]])
                            $('#tags')[0].classList.add('ms-is-invalid')
                            $('.mfc-tags-input')[0].classList.add('ms-is-invalid')
                        } else {
                            EventBus.$emit('error-notification', {
                                "msg": constantMessages.MESSAGES[response.messages[k]]
                            });
                        }
                    }
                } else {
                    self.applicationFormNameBreadcrumb = response.data.name;
                    self.applicationForm.version = response.data.version;
                    EventBus.$emit("success-notification", {
                        msg: constantMessages.MESSAGES["message.form.update"]
                    });
                }
            });
        },
        disableBtnClick() {
            this.deletedReason = "";
            this.updateDialog = true;
            document.getElementById("disableApplicationFormModal").show();
        },
        closeDisableDialog() {
            let form = $('#disableForm')
            form[0].classList.remove("ms-was-validated");
            this.$refs.disableApplicationFormModal.close();
            this.updateDialog = false;
        },
        showTemplateDialog() {
            this.formTemplateData = {
                name: '',
                description: ''
            };
            this.updateTemplateDialog = true;
            document.getElementById("addFormTemplateDialog").show()
        },
        closeTemplateDialog() {
            this.formTemplateData = {
                name: '',
                description: ''
            };
            this.updateTemplateDialog = false;
            this.$refs.addFormTemplateDialog.close()
        },
        saveTemplate(e) {
            let self = this;
            let form = $('#saveTemplateForm')

            
            if (this.formTemplateData.description ) {
                if(!checkFormAndTextareaValidations('formTemplateDescriptionId',this.descRegex,form))
                    {
                        return;
                    }
            } else {
                $(self.$refs.formTemplateDescription)[0].classList.remove("ms-is-invalid");
            }     
            self.formTemplateData.type = "FORM";
            self.formTemplateData.templateData = self.applicationForm.renderedJson;

            TemplateAPI.saveTemplate(
                    self.formTemplateData
                )
                .then(response => {
                    if (response != undefined) {
                        if (response.error) {
                            for (let k in response.messages) {
                                if (k == "name") {
                                    displayErrorMessage($(self.$refs.formTemplateName), constantMessages.MESSAGES[response.messages[k]])
                                    self.$refs.formTemplateName.classList.add("ms-is-invalid")
                                } else if (k == "description") {
                                    displayErrorMessage($(self.$refs.formTemplateDescription), constantMessages.MESSAGES[response.messages[k]])
                                    self.$refs.formTemplateDescription.classList.add("ms-is-invalid")
                                }
                            }
                        } else {
                            $("#addFormTemplateDialog")[0].close()
                            EventBus.$emit("success-notification", {
                                msg: constantMessages.MESSAGES[response.message]
                            });
                        }
                    }
                })
                .finally(() => {});
        },
        disableApplicationForm() {
            let self = this;
            let form = $('#disableForm')

            if(!checkFormAndTextareaValidations('disableReason',this.descRegex,form))
            {
                return;
            }
            self.updateCall = false;
            return ApplicationFormAPI.disableApplicationForm(
                self.applicationId,
                self.formId,
                self.deletedReason
            ).then(response => {
                self.updateCall = true;
                if (!response.error) {
                    EventBus.$emit("success-notification", {
                        msg: constantMessages.MESSAGES[response.message]
                    });
                    document.getElementById("disableApplicationFormModal").close();
                    self.$router.push(process.env.VUE_APP_CONTEXT_PATH + "/design/applications/" + self.applicationId);
                }
            });
        },
        enableApplicationForm() {
            let self = this;
            self.fetchCall = false;
            return ApplicationFormAPI.enableApplicationForm(
                    self.applicationId,
                    self.formId
                )
                .then(response => {
                    if (!response.error) {
                        self.applicationForm.deleted = null;
                        self.applicationForm.deletedReason = null;
                        self.applicationForm.version = response.data.version;
                        EventBus.$emit("success-notification", {
                            msg: constantMessages.MESSAGES[response.message]
                        });
                    }
                })
                .finally(() => {
                    self.fetchCall = true;
                });
        },
        updateName(event) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.required"])
                self.$refs.name.classList.add("ms-is-invalid")
                console.log(1);
            } else if (event.target.value.length > 50) {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.length"])
                self.$refs.name.classList.add("ms-is-invalid")
                console.log(2);
            } else if (!event.target.value.match(this.nameRegex)) {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.invalid"])
                self.$refs.name.classList.add("ms-is-invalid")
                console.log(3);
            } else {
                self.$refs.name.classList.remove("ms-is-invalid")
            }
            self.applicationForm.name = event.target.value;
        },
        updateTemplateName(event) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs.formTemplateName), constantMessages.MESSAGES["error.name.required"])
                self.$refs.formTemplateName.classList.add("ms-is-invalid");
            } else if (event.target.value.length > 50) {
                displayErrorMessage($(self.$refs.formTemplateName), constantMessages.MESSAGES["error.name.length"])
                self.$refs.formTemplateName.classList.add("ms-is-invalid");
            } else if (!event.target.value.match(this.nameRegex)) {
                displayErrorMessage($(self.$refs.formTemplateName), constantMessages.MESSAGES["error.name.invalid"])
                self.$refs.formTemplateName.classList.add("ms-is-invalid")
            }
             else {
                self.$refs.formTemplateName.classList.remove("ms-is-invalid")
            }
            self.formTemplateData.name = event.target.value;
        },
        updateTemplateDescription(event) {
            let self = this;
            if (event.target.value.length > 100) {
                displayErrorMessage($(self.$refs.formTemplateDescription), constantMessages.MESSAGES["error.description.length"])
                self.$refs.formTemplateDescription.classList.add("ms-is-invalid")
            } else if (!event.target.value.match(this.descRegex) && event.target.value != "") {
                displayErrorMessage($(self.$refs.formTemplateDescription), constantMessages.MESSAGES["error.description.invalid"])
                self.$refs.formTemplateDescription.classList.add("ms-is-invalid")
            } else {
                self.$refs.formTemplateDescription.classList.remove("ms-is-invalid")
            }
            self.formTemplateData.description = event.target.value;
        },
        redirectToFormConfirm() {
            if (!this.formAppplication.protected) {
                this.$router.push({
                    path: `${this.CONTEXT_PATH}/applications/` + this.applicationId + '/appforms/' + this.formId + '/formdesigner'
                })
            } else {
                $("#editFormConfirmationDialog")[0].show();
            }
        },
        handleEditFormConfirmDialogClose(e) {
            this.$router.push({
                path: `${this.CONTEXT_PATH}/applications/` + this.applicationId + '/appforms/' + this.formId + '/formdesigner'
            })
        },
        redirectToApplicationList() {
            localStorage.setItem("application", "application");

            this.$router.push(
                this.CONTEXT_PATH + '/design/applications'
            );
        },
        redirectToForm() {
            localStorage.setItem(CONSTANTS.FORMLIST, CONSTANTS.FORMLIST);
            localStorage.setItem(CONSTANTS.PROCESSLIST, CONSTANTS.PROCESSLIST);
        },
        redirectToFormList() {
            localStorage.setItem(CONSTANTS.FORMLIST, CONSTANTS.FORMLIST);

            this.$router.push(
                this.CONTEXT_PATH + '/design/forms'
            );
        },
    }
};
</script>

<style scoped>
.form-designer-component {
  @import "/formdesigner/css/commonStyles.css";
  @import "/formdesigner/styles.css";
}
</style>
<style>
.overlay-div {
    background-color: #e9ecef;
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    z-index: 2;
    opacity: 0.5;
}

.form-preview-parent {
    position: relative;
}

.fieldsetContainer {
    z-index: 1;
}

.mc-forms__valid-feedback {
    display: none;
}

.mc-forms__invalid-feedback {
    display: none;
}
</style>
